export default __webpack_public_path__ + "static/media/lan-1.f5a1f8fc.jpg";